
































	import { Component, Vue, Watch, Provide } from 'vue-property-decorator';
	import { nxExtenManageClient } from "@/api/nxExtenManageClient";
	import { AssignHistoryReq } from "@/pbjs/xcommon/nxExtenManage_pb";
    import { timeFormat, hasProperty } from "@/utils/index";
    import { setCommon, errorMsg, handleResponse } from "@/utils/request";
	@Component({
		name: 'AssignedPhoneHistory'
	})
	export default class AssignedPhoneHistory extends Vue {

		@Provide() private tableData: any = [];
		@Provide() private token: any = "";
		@Provide() private param: any = {
			SuplierType: "",
			ExtNumber: ""
		};
		created() {
			this.token = localStorage.getItem("token");
			this.param = JSON.parse(this.$route.params.item);
		}
		mounted() {
			this.testParam();
			this.assignHistory();
		}
//	lee 参数校验
		private testParam(): boolean {
			if(this.$route.params.item && this.$route.params.item != ":item") {
				if(this.param &&hasProperty(this.param, 'SuplierType') && hasProperty(this.param, 'ExtNumber')) {
					return true;
				}
				// this.$message.error("参数错误");
				// // setTimeout(() => {
				// 	this.$router.push("./login");
				// // }, 500);
				return false;
			}
			this.$message.error("没有要分配的target");
			return false;
		}
//  lee 获取分配历史
		private assignHistoryFuc(data: any) {
			this.tableData = data.historylistList.map((item: any) => {
				item.aDate = timeFormat(Number(item.assigntime));
				item.cDate = item.cancletime==0?0:timeFormat(Number(item.cancletime));
				return item;
			});
		}
		private assignHistory() {
            let request: any = new AssignHistoryReq();
            request.setCommonin(setCommon());
			if(this.testParam()) {
				request.setExtnumber(""+this.param.ExtNumber);
				nxExtenManageClient.assignHistory(request, {}, (err: any, response:any) => {
					if(response) {
						let data: any = response.toObject();
						let _fuc = this.assignHistoryFuc;
						handleResponse(data, _fuc);
						// if (!data.commonout || (data.commonout.code == 0)) {
						// 	this.tableData = data.historylistList.map((item: any) => {
						// 		item.aDate = timeFormat(Number(item.assigntime));
						// 		item.cDate = item.cancletime==0?0:timeFormat(Number(item.cancletime));
						// 		return item;
						// 	});
						// } else {
						// 	this.$message.error(data.commonout.errmsg);
						// }
					}
					if (err) {
       errorMsg(err);
      }
				});
			}
		}
	}
